import { EditorHelper as Helper } from 'a9components/vi-atom-editor/helper';
import { Converter } from './converter';
import { Coords } from './coords';
import { PoolManager } from './breaks/breaks-pool-manager';

// this code probably is no longer in use
export class PagePreview {
    private iframe: HTMLIFrameElement | null;
    private isIE: boolean = false;
    private isReady: boolean = false;
    private isPrinting: boolean = false;
    private margins: { top: number; left: number; right: number; bottom: number };
    private pageHeight: number;
    private pageWidth: number;

    constructor(iframe, margins = {}, size = { width: 210, height: 297 }) {
        this.setFrame(iframe);
        this.setMargins(margins);
        this.setPageSize(size);
        this.setForPrinting(false);

        this.isIE = false;
        this.isReady = false;
    }

    setFrame(iframe) {
        this.iframe = iframe || null;
        this.isReady = false;
    }

    setMargins(margins) {
        this.margins = margins || { top: 0, left: 0, right: 0, bottom: 0 };
    }

    setPageSize(pageSize) {
        let width = pageSize.width || 210; // A4
        let height = pageSize.height || 297; // A4
        if (pageSize.size && pageSize.orientation) {
            const size = Helper.getPageSize(pageSize);
            width = size.width || width;
            height = size.height || height;
        }
        this.pageHeight = height;
        this.pageWidth = width;
    }

    getPageSize() {
        return { width: this.pageWidth, height: this.pageHeight };
    }

    setForPrinting(flag) {
        this.isPrinting = !!flag;
    }

    setContent(content) {
        let promiseResolve = null;
        const promise = new Promise(resolve => {
            promiseResolve = resolve;
        });

        if (!this.iframe || !this.pageHeight) {
            return;
        }

        let body = PagePreview._stripHtmlBody(content);
        body = Helper.clearContent(body);
        const elementContainer = document.createElement('div');
        elementContainer.className = 'document-content';
        for (const i in this.margins)
            if (this.margins.hasOwnProperty(i)) {
                elementContainer.style['padding' + i.charAt(0).toUpperCase() + i.slice(1)] = this.margins[i] + 'mm';
            }
        elementContainer.innerHTML = body || '';

        const html =
            '<!DOCTYPE html>' +
            '<html>' +
            '<head>' +
            '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
            '<link type="text/css" rel="stylesheet" href="./css/styles/tinymce.css">' +
            '<link type="text/css" rel="stylesheet" href="./tinymce/content.css">' +
            '<style>' +
            (this.isPrinting ? '@page{margin: 0; size:' + this.pageWidth + 'mm ' + this.pageHeight + 'mm;}' : '') +
            '</style>' +
            '</head>' +
            '<body>' +
            elementContainer.outerHTML +
            '</body>' +
            '</html>';

        PagePreview._changeWidth(this.iframe, this.pageWidth);

        // let iframeDoc = this.iframe.contentDocument || this.iframe.contentWindow.document;
        if (this.isReady) {
            this._update(html).then(() => promiseResolve());
        } else {
            $(this.iframe).ready(() => {
                this.isReady = true;
                this._update(html).then(() => promiseResolve());
            });
        }
        /*

        if (iframeDoc.readyState === 'complete') {
            console.log("IFRAME: complite");
            this._update(html, promiseResolve);
        } else {
            console.log("IFRAME: reload");
            this.iframe.onload = function () {§§§
                console.log("IFRAME: on reload");
                this._update(html, promiseResolve);
            }.bind(this);
        }
*/

        return promise;
    }

    _update(html) {
        const iframeDoc = this.iframe.contentDocument || (this.iframe.contentWindow && this.iframe.contentWindow.document);
        if (!iframeDoc) {
            return Promise.reject();
        }

        iframeDoc.open();
        iframeDoc.write(html);
        iframeDoc.close();

        return PagePreview._waitForCSSisApplied(this.iframe).then(() => this._addPageBreakers());
    }

    _clearBreaks(doc) {
        const selectors = ['document-page-breaker', 'document-page-breaker-before', 'document-page-breaker-after'];
        selectors.forEach(selector => {
            const elms = doc.getElementsByClassName(selector);
            for (let i = 0; i < elms.length; i++) {
                elms[i].parentElement.removeChild(elms[i]);
            }
        });
    }

    _addPageBreakers() {
        const height = this.pageHeight;
        const margins = this.margins;
        const frame = this.iframe;
        const doc = frame.contentDocument || frame.contentWindow.document;

        this._clearBreaks(doc);

        // let dirtyPageHeight = PagePreview._mmToPx(height);
        const clearPageHeight = PagePreview._mmToPx(height - margins.bottom - margins.top);
        const startHeight = PagePreview._mmToPx(height - margins.bottom);
        const topPadding = PagePreview._mmToPx(margins.top);
        const canvasFilledHeight = PagePreview._getDocumentHeight(frame, doc) - PagePreview._mmToPx(margins.bottom + margins.top);

        const forceBreaks = Array.prototype.slice.call(doc.querySelectorAll('.document-force-page-breaker'));
        const promises = [];
        if (forceBreaks.length) {
            let topShift = topPadding;
            let pages = 0;
            forceBreaks.forEach(b => {
                const rect = b.getBoundingClientRect();
                pages += Math.floor((rect.top - topShift) / clearPageHeight);
                topShift = rect.top;
            });
            if (topShift < canvasFilledHeight + topPadding) {
                pages += Math.floor((canvasFilledHeight + topPadding - topShift) / clearPageHeight);
            }

            pages = pages || 1;

            PagePreview._increaseHeight(frame, pages, height);
            topShift = topPadding;
            forceBreaks.forEach(b => {
                const rect = b.getBoundingClientRect();
                const amount = Math.floor((rect.top - topShift) / clearPageHeight);
                for (let i = 0; i < amount - 1; i++) {
                    const promise = this._createBreakMark(doc, topShift + (i + 1) * clearPageHeight);
                    promises.push(promise);
                }
                topShift = rect.top;
            });
            if (topShift < canvasFilledHeight + topPadding) {
                const amount = Math.floor((canvasFilledHeight + topPadding - topShift) / clearPageHeight);
                for (let i = 0; i < amount - 1; i++) {
                    const promise = this._createBreakMark(doc, topShift + (i + 1) * clearPageHeight);
                    promises.push(promise);
                }
            }
        } else {
            let pages = Math.floor(canvasFilledHeight / clearPageHeight);

            pages = pages || 1;
            PagePreview._increaseHeight(frame, pages, height);
            for (let i = 0; i < pages - 1; i++) {
                const promise = this._createBreakMark(doc, startHeight + i * clearPageHeight);
                promises.push(promise);
            }
        }

        return Promise.all(promises).then(() => {
            const breaks = Array.prototype.slice.call(doc.querySelectorAll('.document-page-breaker, .document-force-page-breaker'));
            breaks.forEach(b => {
                const parent = b.parentNode;
                if (this.isPrinting) {
                    const br1 = PagePreview._createPrintBreak(doc, margins);
                    parent.replaceChild(br1, b);
                } else {
                    const br1 = PagePreview._createBreakBefore(doc, margins, PagePreview._mmToPx(this.pageWidth));
                    const br2 = PagePreview._createBreakAfter(doc, margins);
                    parent.insertBefore(br2, b.nextSibling);
                    parent.replaceChild(br1, b);
                }
            });
        });
    }

    static _getDocumentHeight(frame, doc) {
        return Coords.get({ element: doc.body.lastChild || doc.body, window: frame.contentWindow, document: doc, body: doc.body }).bottom;
    }

    static _mmToPx(mm) {
        return Converter.cm2pixels(mm / 10);
    }

    _createBreakMark(doc: Document, pos: number) {
        let rng: Range | null = null;
        // console.log(doc, doc.caretPositionFromPoint, doc.caretRangeFromPoint,  doc.selection && doc.selection.createRange, doc.body.createTextRange);
        //https://github.com/microsoft/TypeScript/issues/49931
        /*
        if (doc.caretPositionFromPoint) {
            let point = doc.caretPositionFromPoint(0, pos);
            rng = doc.createRange();
            rng.setStart(point.offsetNode, point.offset);
            rng.collapse(true);
        } else */ if (doc.caretRangeFromPoint) {
            const i = 0;
            const left = PagePreview._mmToPx(this.margins.left);
            //while (!rng && (pos - i) > 0) {
            rng = doc.caretRangeFromPoint(left, pos - i);
            //    i++;
            //}
        }

        if (rng === null) {
            return new Promise(res => {
                setTimeout(() => {
                    this._createBreakMark(doc, pos).then(res);
                }, 100);
            });
        } else if (!rng) {
            return Promise.reject();
        }
        let frag, temp;
        const content = `<span class="document-page-breaker" style="display: none"></span>`;

        if (rng) {
            if (rng.insertNode) {
                rng.deleteContents();
                if (rng.createContextualFragment) {
                    rng.insertNode(rng.createContextualFragment(content));
                } else {
                    // Fake createContextualFragment call in IE 9
                    frag = doc.createDocumentFragment();
                    temp = doc.createElement('div');
                    frag.appendChild(temp);
                    temp.outerHTML = content;
                    rng.insertNode(frag);
                }
            } else {
                // @ts-ignore
                rng.pasteHTML(content);
            }
        }

        return Promise.resolve();
    }

    static _createBreakBefore(doc, margin, pxWidth) {
        const element = doc.createElement('p');
        element.classList.add('document-page-breaker-before');
        element.style.margin = '0';
        element.style.padding = margin.bottom + 'mm 0 0 0';
        element.style.lineHeight = '0';
        const br = doc.createElement('div');
        br.style.width = pxWidth + 'px';
        br.style.height = '1px';
        br.display = 'block';
        br.style.background = '#f5f5f5';
        br.style.margin = '0 0 0 -' + margin.left + 'mm';
        element.appendChild(br);

        return element;
    }

    static _createPrintBreak(doc, margin) {
        const element = doc.createElement('p');
        element.classList.add('document-page-breaker-after');
        element.style.margin = '0';
        element.style.pageBreakBefore = 'always';
        element.style.padding = margin.top + 'mm 0 0 0';
        element.style.lineHeight = '0';
        return element;
    }

    static _createBreakAfter(doc, margin) {
        const element = doc.createElement('p');
        element.classList.add('document-page-breaker-after');
        element.style.pageBreakBefore = 'always';
        element.style.margin = '0';
        element.style.padding = margin.top + 'mm 0 0 0';
        element.style.lineHeight = '0';

        return element;
    }

    static _stripHtmlBody(html) {
        const openBodyPos = html.toLowerCase().indexOf('<body');
        if (openBodyPos !== -1) {
            const closeBodyPos = html.indexOf('>', openBodyPos);
            html = html.substring(closeBodyPos + 1);
        }
        const bodyEnd = html.toLowerCase().indexOf('</body>');
        if (bodyEnd !== -1) {
            html = html.substring(0, bodyEnd);
        }
        return html;
    }

    static _increaseHeight(frame, pages = 1, pageHeight = 297) {
        const frameHeight = PagePreview._mmToPx(pages * pageHeight);

        frame.style.minHeight = frameHeight + 'px';
    }

    static _changeWidth(frame, frameWidth = 210) {
        const width = PagePreview._mmToPx(frameWidth);
        frame.style.minWidth = width + 'px';
    }

    static _waitForCSSisApplied(frame) {
        const doc = frame.contentDocument || frame.contentWindow.document;
        const win = frame.contentWindow;
        if (!doc.body) {
            return new Promise(res => {
                win.addEventListener('DOMContentLoaded', () => {
                    PagePreview._waitForCSSisApplied(frame).then(res);
                });
            });
        }
        const waiter = doc.createElement('style');
        waiter.innerHTML = 'body{opacity:1;}';
        return new Promise(res => {
            // will trigger only when all styles are applied
            // function done(evt) {
            //     // some cleanup
            //     waiter.parentNode && waiter.parentNode.removeChild(waiter);
            //     trigger.parentNode && trigger.parentNode.removeChild(trigger);
            //     res();       // resolve the promise
            // }
            // function trigger(){
            //     const trigger = doc.createElement('style');
            //     trigger.innerHTML = 'body{opacity:1;  transition: opacity 1s linear;}';
            //     doc.body.offsetWidth; // trigger a reflow
            //     doc.head.appendChild(trigger);
            // }
            // doc.head.appendChild(waiter);
            // doc.body.addEventListener('transitionend', done);
            //
            // if(doc.readyState !== 'complete'){
            //     // append it only when all resources are fetched
            //     $(win).ready(trigger);
            //     //win.addEventListener('load', trigger);
            // }
            // else{
            //     // wait for the end of current js thread
            //     setTimeout(trigger, 0);
            // }
            setTimeout(res, 1000);
        });
    }
}
